module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg patientList"
  }, [_c('div', {
    staticClass: "titletop"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue",
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("消息列表")]), _vm._v(" "), _c('divider', {
    staticStyle: {
      "margin-top": "46px"
    }
  }, [_vm._v("还有"), _c('em', {
    staticStyle: {
      "color": "#f74c31"
    }
  }, [_vm._v(" " + _vm._s(_vm.unreadNum) + " ")]), _vm._v("条未读消息")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('v-scroll', {
    attrs: {
      "on-refresh": _vm.onRefresh
    }
  }, [_c('ul', _vm._l((_vm.newsList), function(item, index) {
    return (_vm.newsListShow) ? _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.$router.push({
            path: 'patientChatWindow',
            query: {
              patientpersonId: item.patientPersonInfoId,
              personId: _vm.personId,
              isdoctor: 1,
              status: item.status,
              id: item.id,
              title: (item.title).toString()
            }
          })
        }
      }
    }, [_c('div', {
      staticClass: "readdetail"
    }, [_c('p', [_c('span', [_vm._v("姓名："), _c('em', [_vm._v(_vm._s(item.title[0]))])]), _vm._v(" "), _c('span', [_vm._v("性别："), _c('em', [_vm._v(_vm._s(item.title[1]))])]), _vm._v(" "), _c('span', [_vm._v("年龄："), _c('em', [_vm._v(_vm._s(item.title[2]))])]), _vm._v(" "), _c('span', [_vm._v("患者来源："), _c('em', [_vm._v(_vm._s(item.title[3]))])]), _vm._v(" "), _c('span', [_vm._v("介绍人："), _c('em', [_vm._v(_vm._s(item.title[4]))])])])]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(item.createdDate))]), _vm._v(" "), _c('div', {
      staticClass: "readCss"
    }, [_c('span', [_vm._v(_vm._s(item.isReadTxt))]), _c('p', [_vm._v("查看详情"), _c('svg', {
      staticClass: "vux-x-icon vux-x-icon-ios-arrow-right",
      attrs: {
        "type": "ios-arrow-right",
        "size": "20",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "20",
        "height": "20",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "d": "M160 115.4L180.7 96 352 256 180.7 416 160 396.7 310.5 256z"
      }
    })])])])]) : _vm._e()
  }))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23657357","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/onlineServicesProject/doctor/patientList.vue
// module id = Equt
// module chunks = 5